import { render, staticRenderFns } from "./vorgang-verlinkungen-fom.vue?vue&type=template&id=0ccf3f48&scoped=true"
import script from "./vorgang-verlinkungen-fom.vue?vue&type=script&lang=js"
export * from "./vorgang-verlinkungen-fom.vue?vue&type=script&lang=js"
import style0 from "./vorgang-verlinkungen-fom.vue?vue&type=style&index=0&id=0ccf3f48&prod&scoped=true&lang=css"
import style1 from "./vorgang-verlinkungen-fom.vue?vue&type=style&index=1&id=0ccf3f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf3f48",
  null
  
)

export default component.exports